// extracted by mini-css-extract-plugin
export default {"page":"App_page__B3z1R","cashback_img":"App_cashback_img__1e6Uq"};